import React from "react";
import CertifiedBadge from "../../shared/CertifiedBadge";
import ContentCard, { ContentCardProps } from "../../shared/ContentCard";

interface IngredientsTabProps {}

const IngredientsTab: React.FC<IngredientsTabProps> = (props) => {
  const image = "/images/Yellow-pepper.png";
  const content: Array<ContentCardProps> = [
    {
      title: "Ingredient",
      text: "35g",
      imgSrc: image,
      actionElement: <CertifiedBadge type="circle" />,
    },
    {
      title: "Ingredient",
      text: "35g",
      imgSrc: image,
      actionElement: <CertifiedBadge type="inactive" />,
    },
  ];
  return (
    <div className="content-card-wrap">
      {content.map((data, index) => (
        <ContentCard
          key={index}
          title={data.title}
          text={data.text}
          isLinkCard={true}
          imgSrc={data.imgSrc}
          actionElement={data.actionElement}
        />
      ))}
    </div>
  );
};

export default IngredientsTab;
